import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCancelOnCall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={177}
      height={120}
      fill="none"
      {...props}
    >
      <mask id="CancelOnCall_svg__a" fill="#fff">
        <path
          fillRule="evenodd"
          d="M71.781 35c.984 0 1.781.8 1.781 1.786v3.69a6.5 6.5 0 0 1 2.97-.714h24.937c3.607 0 6.531 2.931 6.531 6.547v27.382C108 79.937 102.949 85 96.719 85H81.28C75.051 85 70 79.937 70 73.69V36.787C70 35.8 70.797 35 71.781 35m9.5 14.286c-.984 0-1.781.8-1.781 1.785v13.096c0 .986.797 1.785 1.781 1.785H96.72c.984 0 1.781-.8 1.781-1.785V51.07c0-.986-.797-1.785-1.781-1.785z"
          clipRule="evenodd"
        />
      </mask>
      <path
        stroke="#DB646A"
        strokeWidth={2}
        d="M71.781 35c.984 0 1.781.8 1.781 1.786v3.69a6.5 6.5 0 0 1 2.97-.714h24.937c3.607 0 6.531 2.931 6.531 6.547v27.382C108 79.937 102.949 85 96.719 85H81.28C75.051 85 70 79.937 70 73.69V36.787C70 35.8 70.797 35 71.781 35Zm9.5 14.286c-.984 0-1.781.8-1.781 1.785v13.096c0 .986.797 1.785 1.781 1.785H96.72c.984 0 1.781-.8 1.781-1.785V51.07c0-.986-.797-1.785-1.781-1.785z"
        clipRule="evenodd"
        mask="url(#CancelOnCall_svg__a)"
      />
      <mask id="CancelOnCall_svg__c" fill="#fff">
        <path d="M138.5 60c0 27.614-22.386 50-50 50-13.807 0-26.307-5.596-35.355-14.645C44.096 86.307 38.5 73.807 38.5 60c0-27.614 22.386-50 50-50 13.807 0 26.307 5.596 35.355 14.645C132.904 33.693 138.5 46.193 138.5 60" />
      </mask>
      <path
        fill="url(#CancelOnCall_svg__b)"
        d="M120.32 21.11 49.61 91.82l7.07 7.07 70.711-70.71zM128.5 60c0 22.091-17.909 40-40 40v20c33.137 0 60-26.863 60-60zm-80 0c0-22.091 17.909-40 40-40V0c-33.137 0-60 26.863-60 60zm40-40c11.049 0 21.035 4.466 28.284 11.716l14.142-14.142C120.079 6.727 105.066 0 88.5 0zm28.284 11.716C124.034 38.966 128.5 48.952 128.5 60h20c0-16.566-6.727-31.58-17.574-42.426zM88.5 100c-11.049 0-21.035-4.466-28.284-11.716l-14.142 14.142C56.92 113.273 71.934 120 88.5 120zM60.216 88.284C52.966 81.034 48.5 71.05 48.5 60h-20c0 16.566 6.727 31.58 17.574 42.426z"
        mask="url(#CancelOnCall_svg__c)"
      />
      <defs>
        <linearGradient
          id="CancelOnCall_svg__b"
          x1={88.5}
          x2={88.07}
          y1={10}
          y2={85.533}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCancelOnCall);
export default ForwardRef;
